module.exports = __webpack_public_path__ + "styleguide.3278894b.mp4";